import "./Css/Access.css";
import { useTranslation } from "react-i18next";


function AccessRights() {
  const { t, i18n } = useTranslation();

  return (
    <div className="AccessRightWrapp">
      <h6 className="AccessTitle">
        {t("access-rights")}
      </h6>
    </div>
  );
}

export default AccessRights;
